export default __webpack_public_path__ + "static/media/blog-driveway-size-004.e8e2d662.jpg";